import { Link } from "react-router-dom";
import React from "react";

const Lender = ({ lender }) => {
  return <Link to={"/lender/item/" + lender.id}>{lender.title}</Link>;
};

export default Lender;
